module.exports = __webpack_public_path__ + "img/xaklogin2.c62d86ee.png";